import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0dc3335d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0dc3335d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3335d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc3335d')) {
      api.createRecord('0dc3335d', component.options)
    } else {
      api.reload('0dc3335d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0dc3335d&scoped=true&", function () {
      api.rerender('0dc3335d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/list/index.vue"
export default component.exports